export const OperatingManual = () => {
    return (
        <object
            aria-labelledby="User Guide File"
            data={process.env.PUBLIC_URL + '/User_Guide.pdf'}
            type="application/pdf"
            width="100%"
            height="99%"
        />
    )
}
